module.exports = __webpack_public_path__ + "static/img/pic_home_title.120c39f.png";


//////////////////
// WEBPACK FOOTER
// ./static/staticPages/pic_home_title.png
// module id = lBqg
// module chunks = 83